interface SectionHeaderProps {
  title: string
}

export function SectionHeader({ title }: SectionHeaderProps) {
  return (
    <div className="flex items-center mb-4">
      <div className="h-px flex-1 bg-border" />
      <h2 className="px-4 text-heading font-bold">{title}</h2>
      <div className="h-px flex-1 bg-border" />
    </div>
  )
}
